<template>
    <div class="form">
        <Form ref="info" :model="info" :rules="ruleValidate" :label-width="100">
            <Row :gutter="20">
                <Col span="12">
                    <FormItem label="园区名称" prop="parkName">
                        <Input
                            v-model="info.parkName"
                            :maxlength="50"
                            :disabled="true"
                        ></Input>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="园区类型" prop="parkType">
                        <Select v-model="info.parkType" transfer :disabled="parkHouseCount > 0">
                            <Option
                                v-for="(item, index) in dict.parkType.options
                                    .list"
                                :value="item.id"
                                :key="index"
                                >{{ item.text }}</Option
                            >
                        </Select>
                    </FormItem>
                </Col>
            </Row>
            <!-- 查小区公寓 -->
            <form-location
                spread-out
                :model="location"
                type="120100|120200|120201|120202120203|120300|120301|120302|120303|120304"
                :onChange="locationChange"
                :showKeyWordForm = "parkHouseCount == 0"
            ></form-location>
            <Row :gutter="20">
                <Col span="24">
                    <FormItem label="备注" prop="remark">
                        <Input
                            v-model="info.remark"
                            type="textarea"
                            :rows="3"
                            placeholder
                        ></Input>
                    </FormItem>
                </Col>
            </Row>
        </Form>
    </div>
</template>
<script>
import mForm from '_v/common/m-form'
import {
    assetsParkAdd,
    assetsParkUpdate,
    assetsParkView,
    countHouseById,
} from '@/api/configuration'
import FormLocation from '_c/form-location'
import Dict from '_u/dict'

export default {
    name: 'c-park-form',
    mixins: [mForm],
    props: {
        id: {
            type: [String, Number],
            default: '',
        },
    },
    components: { FormLocation },
    inject: {
        $modal: {
            default: null,
        },
    },
    data() {
        return {
            info: {
                id: this.id,
                parkName: '', // 园区名称
                parkType: '', // 园区类型
                addr: '', // 详细地址
                district: '', // 行政区
                remark: '', // 备注
                ver: '', // 版本
            },
            location: {
                longitude: '',
                latitude: '',
                addr: '',
                district: '',
            },
            dict: {
                parkType: Dict.NULL,
            },
            parkHouseCount:0,//园区下的有效房源数
        }
    },
    computed: {
        ruleValidate() {
            return {
                parkName: [{ required: true, message: '园区名称必填' }],
                parkType: [{ required: true, message: '园区类型必填' }],
                addr: [{ required: true, message: '详细地址必填' }],
            }
        },
    },
    methods: {
        fetch() {
            if (this.id) {
                return assetsParkView(this.id)
            } else {
                return Promise.resolve()
            }
        },
        //监听子组件选中联想出来的地址事件
        locationChange(val) {
            this.info.parkName = val
        },
    },
    mounted() {
        var $info = this.$refs.info

        window.t = this

        // 按钮配置
        var btns = [{ type: 'default', text: '取消', name: 'cancel' }]

        if (this.$can('update')) {
            btns.unshift({
                type: 'primary',
                name: 'confirm',
                text: '确定',
            })
        }
        this.$modal.updateBtns(btns)

        // 预加载
        this.$modal.beforeEnter((next) => {
            Promise.all([this.fetch(), Dict.get(['park_type'])])
                .then((args) => {
                  //查询该园区下是否有房间
                    var [view, dictGroup] = args

                    Object.keys(this.dict).forEach((name) => {
                        this.dict[name] = dictGroup[name]
                    })

                    if (view) {
                        var viewData = view.data.entity
                        // 实体数据
                        if (viewData.entity) viewData = viewData.entity
                        var lonlatVal = JSON.safeParse(viewData.lonlat) || {}
                        Object.keys(this.info).forEach(
                            (name) => (this.info[name] = viewData[name])
                        )
                        this.location = {
                            longitude: lonlatVal.longitude,
                            latitude: lonlatVal.latitude,
                            addr: viewData.addr,
                            district: viewData.district,
                        }
                    }
                })
                .finally(() => {
                  if (this.id){
                    countHouseById(this.id).then((arges) =>{
                      this.parkHouseCount = arges.count
                      //隐藏位置输入框，其它所有表单（除备注外）都禁用
                      next()
                    })

                  }else {
                    next()
                  }

                })

        })

        // 确定
        this.$modal.onBtnClick('confirm', (next, options) => {
            $info
                .validate()
                .then(() => {
                    var formData = Object.assign(
                        {
                            id: this.info.id,
                            ver: this.info.ver,
                            district: this.info.district,
                        },
                        $info.populateData()
                    )

                    if (this.id) {
                        return assetsParkUpdate(formData)
                    } else {
                        return assetsParkAdd(formData)
                    }
                })
                .then((res) => {
                    if (this.id) {
                        this.$Message.success(this.$t('tips.update.success'))
                    } else {
                        this.$Message.success(this.$t('tips.add.success'))
                    }
                })
                .catch((err) => {
                    options.closeModal = false
                })
                .finally(() => {
                    next()
                })
        })
    },
}
</script>
<style lang="less" scoped>
.note {
    font-size: 14px;
    font-weight: 400;
    text-align: left;
    color: rgb(170, 170, 170);
}
</style>
